import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <div className="grid min-h-[60dvh] place-items-center text-center">
      <div className="space-y-3">
        <h1 className="text-3xl font-semibold">404</h1>
        <p className="text-sm text-[var(--muted-foreground)]">This page does not exist.</p>
        <Link to="/" className="text-[var(--accent)] underline">
          Back to overview
        </Link>
      </div>
    </div>
  );
}
